const API_BASE = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE || 'http://localhost:8000';

const getAccessToken = () => localStorage.getItem('access_token');
const getRefreshToken = () => localStorage.getItem('refresh_token');

const setTokens = (access, refresh) => {
  if (access) localStorage.setItem('access_token', access);
  if (refresh) localStorage.setItem('refresh_token', refresh);
};

const clearTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('auth_user');
};

async function refreshToken() {
  const refresh = getRefreshToken();
  if (!refresh) return null;
  const res = await fetch(`${API_BASE}/api/auth/token/refresh/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh })
  });
  if (!res.ok) return null;
  const data = await res.json();
  // SimpleJWT returns { access }
  if (data?.access) setTokens(data.access, refresh);
  return data?.access || null;
}

export async function apiFetch(path, options = {}, retry = true) {
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;
  const headers = new Headers(options.headers || {});
  if (!headers.has('Content-Type') && !(options.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }
  const token = getAccessToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);

  const res = await fetch(url, { ...options, headers });
  if (res.status !== 401 || !retry) return res;

  // Check if it's a token_expired error (inactivity timeout)
  try {
    const errorData = await res.clone().json();
    if (errorData?.detail?.includes('inactivity') || errorData?.code === 'token_expired') {
      clearTokens();
      if (window.location.pathname.startsWith('/admin')) {
        alert('Your session expired due to inactivity. Please login again.');
        window.location.assign('/admin/login');
      }
      return res;
    }
  } catch (e) {
    // If error parsing fails, continue with normal refresh flow
  }

  // Try refresh once
  const newAccess = await refreshToken();
  if (!newAccess) {
    clearTokens();
    // Hard redirect to login to avoid importing store here
    if (window.location.pathname.startsWith('/admin')) {
      window.location.assign('/admin/login');
    }
    return res;
  }

  const retryHeaders = new Headers(options.headers || {});
  if (!retryHeaders.has('Content-Type') && !(options.body instanceof FormData)) {
    retryHeaders.set('Content-Type', 'application/json');
  }
  retryHeaders.set('Authorization', `Bearer ${newAccess}`);

  const retryRes = await fetch(url, { ...options, headers: retryHeaders });

  // For retry response, parse JSON if successful
  if (retryRes.ok) {
    try {
      return await retryRes.json();
    } catch (e) {
      console.error('Failed to parse JSON response on retry:', e);
      return retryRes;
    }
  }

  return retryRes;
}

export { API_BASE };
